"use client";

import { useEffect } from "react";
import { captureError } from "@/lib/sentry";
import { useT } from "@/lib/i18n";

export default function GlobalError({
  error,
  reset,
}: {
  error: Error & { digest?: string };
  reset: () => void;
}) {
  const t = useT();
  useEffect(() => {
    captureError(error, { digest: error.digest });
    // eslint-disable-next-line no-console
    console.error(error);
  }, [error]);

  return (
    <div className="min-h-screen flex items-center justify-center" style={{ backgroundColor: "var(--page-bg)" }}>
      <div className="text-center px-6 max-w-md">
        <p className="text-6xl font-bold" style={{ color: "var(--error-ink)" }}>500</p>
        <h1 className="mt-4 text-xl font-semibold" style={{ color: "var(--text-primary)" }}>
          {t("err.title")}
        </h1>
        <p className="mt-2 text-base" style={{ color: "var(--text-muted)" }}>
          {t("err.body")}
        </p>
        {error.digest && (
          <p className="mt-2 text-sm font-mono" style={{ color: "var(--text-muted)" }}>
            {t("err.reference", { ref: error.digest })}
          </p>
        )}
        <div className="mt-6 flex gap-2 justify-center">
          <button
            onClick={() => reset()}
            className="px-4 py-2 rounded-lg text-base font-medium text-white"
            style={{ backgroundColor: "var(--primary)" }}
          >
            {t("common.retry")}
          </button>
          <a
            href="/dashboard"
            className="px-4 py-2 rounded-lg text-base font-medium border"
            style={{ borderColor: "var(--border)", color: "var(--text-primary)" }}
          >
            {t("err.toDashboard")}
          </a>
        </div>
      </div>
    </div>
  );
}
